<template>
  <b-row class="gutters-0 new-gutters-xs">
    <b-col cols="4">
      <b-form-input
        :value="search"
        @input="setFilterSearch($event)"
        id="search-by-headline"
        class="cols-auto"
        type="text"
        size="sm"
        placeholder="Search"
        autocomplete="off"
      />
    </b-col>
    <b-col cols="2">
      <b-form-select
        :options="stateFilters"
        :value="selectedStateFilter"
        @change="setFilterState($event)"
        size="sm"
      >
        <template v-slot:first>
          <b-form-select-option
            v-if="selectedState"
            :value="null"
            name="State"
          >
            All States
          </b-form-select-option>
        </template>
        <b-form-select-option
          value="placeholder"
          name="State"
          class="d-none"
          disabled
        >
          State
        </b-form-select-option>
      </b-form-select>
    </b-col>
    <b-col
      cols="3"
    >
      <b-form-select
        :options="languages"
        :value="selectedLanguageFilter"
        @change="setFilterLanguage($event)"
        size="sm"
        text-field="name"
        value-field="id"
      >
        <template v-slot:first>
          <b-form-select-option
            v-if="selectedLanguageId"
            :value="null"
            name="Language"
          >
            All Languages
          </b-form-select-option>
        </template>
        <b-form-select-option
          value="placeholder"
          name="Language"
          class="d-none"
          disabled
        >
          Language
        </b-form-select-option>
      </b-form-select>
    </b-col>
    <b-col
      cols="3"
    >
      <b-form-select
        :options="matchingHealths"
        :value="selectedMatchingHealthFilter"
        @change="setFilterMatchingHealth($event)"
        size="sm"
      >
        <template v-slot:first>
          <b-form-select-option
            v-if="selectedMatchingHealth"
            :value="null"
            name="Matching Health"
          >
            All Matching Healths
          </b-form-select-option>
        </template>
        <b-form-select-option
          value="placeholder"
          name="Matching Health"
          class="d-none"
          disabled
        >
          Matching Health
        </b-form-select-option>
      </b-form-select>
    </b-col>
  </b-row>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import * as contentTypes from '@/modules/content/store/types';

import helper from '@/core/helper';

export default {
  name: 'ArticlesFilters',
  data() {
    return {
      search: null,
      stateFilters: [],
      selectedState: null,
      selectedLanguageId: null,
      selectedMatchingHealth: null,
    };
  },
  created() {
    this.selectFilters();
  },
  destroyed() {
    this.saveFilters();
  },
  computed: {
    ...mapState('campaigns', [
      'campaign',
    ]),
    ...mapState('content', [
      'languages',
      'totalItems',
    ]),
    ...mapGetters('content', [
      contentTypes.GET_FAILED_SCRAPED_CONTENT_ITEMS,
    ]),
    matchingHealths() {
      return [
        { value: 'LOW', text: 'Low' },
        { value: 'MEDIUM', text: 'Medium' },
        { value: 'HIGH', text: 'High' },
      ];
    },
    selectedStateFilter() {
      if (!this.selectedState) return 'placeholder';
      return this.selectedState;
    },
    selectedLanguageFilter() {
      if (!this.selectedLanguageId) return 'placeholder';
      return this.selectedLanguageId;
    },
    selectedMatchingHealthFilter() {
      if (!this.selectedMatchingHealth) return 'placeholder';
      return this.selectedMatchingHealth;
    },
  },
  methods: {
    ...mapActions('content', [
      contentTypes.SET_CONTENT_ITEM_QUERY_PARAM,
      contentTypes.FETCH_ARTICLES,
      contentTypes.FETCH_CONTENT_STATES,
    ]),
    selectFilters() {
      const articleFilters = sessionStorage.getItem('articleFilters');
      const articleFiltersForCampaign = articleFilters ? JSON.parse(articleFilters)[this.campaign.id] : undefined;
      if (articleFiltersForCampaign) {
        if (articleFiltersForCampaign.stateFilter) this.setFilterState(articleFiltersForCampaign.stateFilter);
        if (articleFiltersForCampaign.languageFilter) this.setFilterLanguage(articleFiltersForCampaign.languageFilter);
        if (articleFiltersForCampaign.matchingHealthFilter) this.setFilterMatchingHealth(articleFiltersForCampaign.matchingHealthFilter);

        this.selectedState = articleFiltersForCampaign.stateFilter;
        this.selectedLanguageId = articleFiltersForCampaign.languageFilter;
        this.selectedMatchingHealth = articleFiltersForCampaign.matchingHealthFilter;
      }
    },
    saveFilters() {
      const articleFilters = JSON.parse(localStorage.getItem('articleFilters') || '{}');
      articleFilters[this.campaign.id] = {
        stateFilter: this.selectedState,
        languageFilter: this.selectedLanguageId,
        matchingHealthFilter: this.selectedMatchingHealth,
      };
      sessionStorage.setItem('articleFilters', JSON.stringify(articleFilters));
    },
    setFilterSearch: helper.debounce(function setFilterSearch(text) {
      this.search = text || null;
      this.SET_CONTENT_ITEM_QUERY_PARAM({ search: this.search ? encodeURIComponent(this.search) : null });
      this.SET_CONTENT_ITEM_QUERY_PARAM({ page: 1 });
      this.$emit('resetSelectedIds');
      if (this.selectedState !== 'FAILED') this.fetchArticles();
    }, 500),
    setFilterState(state) {
      this.selectedState = state || null;
      this.SET_CONTENT_ITEM_QUERY_PARAM({ states: this.selectedState });
      this.SET_CONTENT_ITEM_QUERY_PARAM({ page: 1 });
      this.$emit('resetSelectedIds');
      if (state !== 'FAILED') this.fetchArticles();
    },
    setFilterLanguage(languageId) {
      this.selectedLanguageId = languageId || null;
      this.SET_CONTENT_ITEM_QUERY_PARAM({ languageId: this.selectedLanguageId });
      this.SET_CONTENT_ITEM_QUERY_PARAM({ page: 1 });
      this.$emit('resetSelectedIds');
      if (this.selectedState !== 'FAILED') this.fetchArticles();
    },
    setFilterMatchingHealth(status) {
      this.selectedMatchingHealth = status || null;
      this.SET_CONTENT_ITEM_QUERY_PARAM({ matchingHealth: this.selectedMatchingHealth });
      this.SET_CONTENT_ITEM_QUERY_PARAM({ page: 1 });
      this.$emit('resetSelectedIds');
      if (this.selectedState !== 'FAILED') this.fetchArticles();
    },
    fetchArticles() {
      this.$emit('fetchArticles');
    },
  },
  async mounted() {
    this.FETCH_CONTENT_STATES()
      .then((response) => {
        const states = [];
        response.forEach((state) => {
          const stateText = state.charAt(0).toUpperCase() + state.slice(1).toLowerCase();
          states.push({ value: state, text: stateText });
        });
        states.push({ value: 'FAILED', text: 'Failed' });
        states.sort((a, b) => {
          const textA = a.value.toUpperCase();
          const textB = b.value.toUpperCase();
          if (textA < textB) return -1;
          return (textA > textB) ? 1 : 0;
        });
        this.stateFilters = states;
      });
  },
};
</script>
